import PropTypes from 'prop-types'

export default function PartnerCard({ partner, onViewStats, onEditRules, onRemove, onBlock }) {
  const successRate = partner.partnership?.total_matches > 0
    ? ((partner.partnership.successful_matches / partner.partnership.total_matches) * 100).toFixed(1)
    : 0

  return (
    <div className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-3">
        <div>
          <h3 className="font-semibold text-gray-900">{partner.name}</h3>
          <p className="text-sm text-gray-600">{partner.city}</p>
        </div>
        <span className="px-2 py-1 bg-green-100 text-green-800 text-xs font-medium rounded">
          Partenaire
        </span>
      </div>

      {/* Stats */}
      {partner.partnership && (
        <div className="grid grid-cols-2 gap-2 mb-3 text-sm">
          <div>
            <div className="text-gray-600">Matches</div>
            <div className="font-semibold">{partner.partnership.total_matches || 0}</div>
          </div>
          <div>
            <div className="text-gray-600">Succès</div>
            <div className="font-semibold">{successRate}%</div>
          </div>
        </div>
      )}

      {/* Commission custom */}
      {partner.partnership?.custom_rules?.commission_split && (
        <div className="mb-3 p-2 bg-blue-50 rounded text-sm">
          <span className="font-medium">Commission: </span>
          {partner.partnership.custom_rules.commission_split.source}% /
          {partner.partnership.custom_rules.commission_split.target}%
        </div>
      )}

      {/* Actions */}
      <div className="flex gap-2">
        <button
          onClick={onViewStats}
          className="flex-1 px-3 py-2 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-200 hover:bg-blue-100 rounded-md transition-colors"
        >
          📊 Stats
        </button>
        <button
          onClick={onEditRules}
          className="flex-1 px-3 py-2 text-sm font-medium text-purple-700 bg-purple-50 border border-purple-200 hover:bg-purple-100 rounded-md transition-colors"
        >
          ⚙️ Règles
        </button>
      </div>

      <div className="flex gap-2 mt-2">
        <button
          onClick={onRemove}
          className="flex-1 px-3 py-2 text-sm font-medium text-orange-700 bg-orange-50 border border-orange-200 hover:bg-orange-100 rounded-md transition-colors"
        >
          Retirer
        </button>
        <button
          onClick={onBlock}
          className="flex-1 px-3 py-2 text-sm font-medium text-red-700 bg-red-50 border border-red-200 hover:bg-red-100 rounded-md transition-colors"
        >
          Bloquer
        </button>
      </div>
    </div>
  )
}

PartnerCard.propTypes = {
  partner: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    city: PropTypes.string,
    partnership: PropTypes.shape({
      total_matches: PropTypes.number,
      successful_matches: PropTypes.number,
      custom_rules: PropTypes.object
    })
  }).isRequired,
  onViewStats: PropTypes.func.isRequired,
  onEditRules: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onBlock: PropTypes.func.isRequired
}
